import React from 'react';
import { styled } from '@linaria/react';

interface Props {
  children: React.ReactNode;
  enabled: boolean;
  defaultRotation?: number;
  style?: React.CSSProperties;
}

const AutoRotate = ({
  children,
  enabled,
  defaultRotation = 30,
  style = {},
  ...delegated
}: Props) => {
  return (
    <Wrapper
      data-enable-animation={enabled}
      style={{
        '--initial-rotation': `${defaultRotation}deg`,
        // We want the card to sit at an angle when the spin is not enabled, so that the effect is still visible:
        transform: `rotateX(${defaultRotation}deg)`,
        ...style,
      }}
      {...delegated}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @keyframes fullRotation {
    from {
      transform: rotateX(var(--initial-rotation));
    }
    to {
      transform: rotateX(calc(var(--initial-rotation) + 360deg));
    }
  }

  /*
    We aren’t gating behind prefers-reduced-motion because this animation is opt-in.
  */
  animation: fullRotation 4000ms linear infinite;
  will-change: transform;

  &[data-enable-animation='false'] {
    animation: revert;
  }
`;

export default AutoRotate;
